<template>
  <div
    data-testid="team-jersey"
    :class="[layoutClass, classes.container, 'team-jersey']"
  >
    <div :class="classes.body">
      <svg
        :class="[classes.svg, 'helmet']"
        height="100%"
        width="100%"
        viewBox="0 0 500 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_807_20)">
          <path
            id="upper"
            d="M308.907 132.936C327.365 135.656 345.336 139.582 362.446 146.641C369.671 149.621 376.554 153.218 383.121 157.446C398.476 167.337 409.653 180.683 417.846 196.607C421.279 203.283 424.603 210.002 426.192 217.352C427.402 222.946 428.447 228.584 429.251 234.246C430.992 246.51 431.258 258.861 431.125 271.218C431.043 278.753 430.713 286.283 430.378 293.812C430.201 297.731 430.03 301.681 429.384 305.544C428.535 310.626 424.926 313.642 419.613 314.6C414.972 315.435 410.336 314.885 405.708 314.736C401.687 314.606 397.672 314.285 393.657 314.013C388.927 313.692 384.203 313.339 379.473 312.993C375.269 312.684 371.07 312.375 366.866 312.047C362.522 311.707 358.184 311.343 353.847 310.996C350.123 310.694 346.406 310.366 342.683 310.131C342.17 310.1 341.474 310.415 341.125 310.799C333.9 318.637 326.327 326.129 318.114 332.984C302.904 345.681 286.06 355.683 267.336 362.674C256.305 366.791 245.009 369.962 233.484 372.348C226.772 373.739 219.997 374.932 213.189 375.736C206.579 376.515 199.898 376.286 193.243 375.662C172.454 373.708 153.192 366.865 134.638 357.995C123.063 352.462 111.798 346.312 100.425 340.377C99.3552 339.821 98.5574 339.735 97.4366 340.235C89.268 343.87 80.8968 346.961 72.076 348.741C64.5597 350.256 56.9991 350.911 49.5334 348.556C43.6128 346.689 39.1992 343.017 36.5523 337.441C35.5329 335.29 35.7038 333.114 36.7676 331.093C39.4145 326.061 43.1568 321.944 47.9313 318.705C60.7097 310.044 74.134 302.41 87.5393 294.745C101.394 286.827 115.357 279.081 129.256 271.224C129.718 270.958 130.161 270.384 130.294 269.871C132.84 260.042 135.291 250.182 137.861 240.36C141.692 225.722 145.72 211.127 151.14 196.953C155.003 186.858 160.708 177.759 167.477 169.296C176.678 157.799 187.652 148.223 200.335 140.49C209.384 134.97 219.04 131.082 229.609 129.413C239.145 127.905 248.757 127.379 258.389 127.732C265.709 127.997 273.01 128.609 280.317 129.085C281.299 129.147 282.014 129.135 282.641 128.065C284.357 125.179 287.112 123.683 290.512 123.812C294.178 123.948 297.889 124.122 301.479 124.795C305.855 125.617 308.457 128.442 308.92 132.955L308.907 132.936Z"
            :fill="teamColors?.helmets.background"
          />
          <path
            id="peak"
            d="M225.474 279.242C199.062 269.036 173.721 266.78 152.634 267.818C145.948 268.152 139.685 268.814 133.954 269.661C133.688 269.698 133.416 269.741 133.15 269.778C133.144 269.803 133.138 269.821 133.131 269.846C132.998 270.359 132.561 270.94 132.093 271.2C118.2 279.056 104.237 286.802 90.3762 294.727C76.9709 302.386 63.5466 310.02 50.7682 318.68C45.9937 321.919 42.2514 326.036 39.6045 331.068C38.5407 333.096 38.3697 335.265 39.3892 337.417C42.0361 342.999 46.4559 346.67 52.3766 348.537C59.8422 350.892 67.4029 350.237 74.9192 348.723C83.7337 346.942 92.1049 343.852 100.273 340.217C101.394 339.716 102.192 339.803 103.262 340.359C114.635 346.293 125.9 352.444 137.475 357.977C156.029 366.853 175.297 373.696 196.086 375.65C202.741 376.274 209.422 376.503 216.033 375.724C222.84 374.92 229.615 373.727 236.327 372.336C247.852 369.956 259.155 366.779 270.179 362.668C288.91 355.677 305.754 345.675 320.964 332.978C329.177 326.123 345.533 310.125 345.533 310.125C327.1 308.128 305.798 304.623 282.565 298.541C260.795 292.841 241.691 286.023 225.474 279.242V279.242Z"
            :fill="teamColors?.helmets.accent"
          />
          <g opacity="0.2">
            <path
              d="M230.274 129.753C219.705 131.422 210.049 135.31 201 140.83C188.316 148.564 177.336 158.139 168.142 169.637C161.367 178.093 155.661 187.192 151.799 197.293C146.378 211.467 142.351 226.056 138.52 240.694C135.949 250.522 133.499 260.376 130.953 270.204C130.82 270.717 130.383 271.299 129.915 271.558C116.022 279.415 102.059 287.16 88.2042 295.085C74.7989 302.744 61.3683 310.378 48.5899 319.039C43.8154 322.278 40.0731 326.395 37.4262 331.427C36.3624 333.448 36.1914 335.624 37.2173 337.775C38.0341 339.494 39.0156 341.027 40.1554 342.387L151.704 266.508C151.704 266.508 155.744 163.251 255.527 127.979C247.073 127.862 238.645 128.43 230.274 129.753V129.753Z"
              fill="white"
            />
          </g>
          <path
            d="M308.907 132.937C308.445 128.424 305.842 125.599 301.467 124.777C297.876 124.103 294.166 123.93 290.499 123.794C287.099 123.664 284.345 125.16 282.628 128.047C281.995 129.11 281.286 129.129 280.305 129.067C272.997 128.591 265.69 127.979 258.376 127.713C248.738 127.367 239.133 127.892 229.596 129.395C219.034 131.064 209.371 134.958 200.322 140.472C187.639 148.205 176.659 157.786 167.465 169.278C160.695 177.741 154.984 186.84 151.127 196.934C145.707 211.109 141.68 225.697 137.849 240.341C135.278 250.164 132.827 260.023 130.282 269.852C130.149 270.365 129.712 270.946 129.243 271.206C115.344 279.063 101.388 286.808 87.5267 294.727C74.1214 302.392 60.6908 310.026 47.9187 318.686C43.1442 321.926 39.4019 326.043 36.755 331.074C35.6912 333.096 35.5202 335.272 36.5397 337.423C39.1866 342.999 43.6001 346.67 49.5207 348.537C56.9864 350.892 64.5471 350.237 72.0634 348.723C80.8779 346.942 89.2554 343.852 97.4239 340.217C98.5447 339.716 99.3426 339.803 100.413 340.359C111.785 346.293 123.05 352.444 134.626 357.976C153.179 366.847 172.442 373.696 193.23 375.643C199.885 376.268 206.566 376.496 213.177 375.718C219.984 374.914 226.759 373.721 233.472 372.33C244.996 369.944 256.293 366.773 267.324 362.656C286.054 355.671 302.898 345.663 318.102 332.966C326.314 326.111 333.888 318.618 341.113 310.78C341.467 310.397 342.164 310.082 342.671 310.113C346.394 310.348 350.117 310.675 353.834 310.978C358.172 311.33 362.516 311.695 366.853 312.029C371.051 312.357 375.256 312.666 379.461 312.975C384.191 313.321 388.915 313.673 393.645 313.995C397.659 314.267 401.674 314.588 405.695 314.718C410.33 314.866 414.965 315.416 419.601 314.582C424.92 313.624 428.523 310.607 429.371 305.526C430.017 301.662 430.188 297.712 430.365 293.793C430.701 286.264 431.03 278.729 431.113 271.2C431.252 258.843 430.98 246.492 429.238 234.228C428.434 228.565 427.389 222.928 426.18 217.333C424.59 209.984 421.266 203.258 417.834 196.588C409.64 180.664 398.464 167.318 383.108 157.428C376.542 153.2 369.658 149.602 362.433 146.623C345.324 139.563 327.353 135.638 308.894 132.918L308.907 132.937Z"
            stroke="#0D0D0D"
            stroke-width="9"
            stroke-miterlimit="10"
          />
          <path
            d="M308.907 132.936C327.365 135.656 345.336 139.582 362.446 146.641C369.671 149.621 376.554 153.218 383.121 157.446C398.476 167.337 409.653 180.683 417.846 196.607C421.279 203.283 424.603 210.002 426.192 217.352C427.402 222.946 428.447 228.584 429.251 234.246C430.992 246.51 431.258 258.861 431.125 271.218C431.043 278.753 430.713 286.283 430.378 293.812C430.201 297.731 430.03 301.681 429.384 305.544C428.535 310.626 424.926 313.642 419.613 314.6C414.972 315.435 410.336 314.885 405.708 314.736C401.687 314.606 397.672 314.285 393.657 314.013C388.927 313.692 384.203 313.339 379.473 312.993C375.269 312.684 371.07 312.375 366.866 312.047C362.522 311.707 358.184 311.343 353.847 310.996C350.123 310.694 346.406 310.366 342.683 310.131C342.17 310.1 341.474 310.415 341.125 310.799C333.9 318.637 326.327 326.129 318.114 332.984C302.904 345.681 286.06 355.683 267.336 362.674C256.305 366.791 245.009 369.962 233.484 372.348C226.772 373.739 219.997 374.932 213.189 375.736C206.579 376.515 199.898 376.286 193.243 375.662C172.454 373.708 153.192 366.865 134.638 357.995C123.063 352.462 111.798 346.312 100.425 340.377C99.3552 339.821 98.5574 339.735 97.4366 340.235C89.268 343.87 80.8968 346.961 72.076 348.741C64.5597 350.256 56.9991 350.911 49.5334 348.556C43.6128 346.689 39.1992 343.017 36.5523 337.441C35.5329 335.29 35.7038 333.114 36.7676 331.093C39.4145 326.061 43.1568 321.944 47.9313 318.705C60.7097 310.044 74.134 302.41 87.5393 294.745C101.394 286.827 115.357 279.081 129.256 271.224C129.718 270.958 130.161 270.384 130.294 269.871C132.84 260.042 135.291 250.182 137.861 240.36C141.692 225.722 145.72 211.127 151.14 196.953C155.003 186.858 160.708 177.759 167.477 169.296C176.678 157.799 187.652 148.223 200.335 140.49C209.384 134.97 219.04 131.082 229.609 129.413C239.145 127.905 248.757 127.379 258.389 127.732C265.709 127.997 273.01 128.609 280.317 129.085C281.299 129.147 282.014 129.135 282.641 128.065C284.357 125.179 287.112 123.683 290.512 123.812C294.178 123.948 297.889 124.122 301.479 124.795C305.855 125.617 308.457 128.442 308.92 132.955L308.907 132.936Z"
            stroke="#0D0D0D"
            stroke-width="9"
            stroke-miterlimit="10"
          />
          <path
            d="M297.718 132.139C297.718 132.139 343.842 150.832 341.702 181.592C339.555 212.351 331.69 294.85 326.682 310.125"
            stroke="#0D0D0D"
            stroke-width="8"
            stroke-miterlimit="10"
          />
          <path
            d="M263.854 127.967C263.854 127.967 320.394 134.204 341.132 139.44"
            stroke="#0D0D0D"
            stroke-width="8"
            stroke-miterlimit="10"
          />
          <path
            d="M127.629 272.906C127.629 272.906 154.984 253.112 222.612 279.242C290.24 305.371 342.67 310.125 342.67 310.125"
            stroke="#0D0D0D"
            stroke-width="8"
            stroke-miterlimit="10"
          />
          <path
            d="M100.406 340.365C100.406 340.365 64.889 317.957 36.5334 337.423"
            stroke="#0D0D0D"
            stroke-width="8"
            stroke-miterlimit="10"
          />
          <path
            opacity="0.2"
            d="M428.447 272.999C428.358 280.534 428.035 288.069 427.693 295.598C427.516 299.517 427.345 303.467 426.699 307.325C425.85 312.412 422.241 315.429 416.928 316.381C412.287 317.215 407.652 316.671 403.017 316.517C399.306 316.399 395.601 316.115 391.897 315.855C392.005 303.072 392.518 280.639 394.189 242.666C396.425 191.964 366.429 159.295 347.819 144.026C351.846 145.343 355.829 146.802 359.774 148.428C366.993 151.407 373.876 154.999 380.442 159.233C395.798 169.117 406.974 182.469 415.168 198.387C418.6 205.063 421.924 211.789 423.514 219.139C424.723 224.727 425.768 230.37 426.572 236.027C428.307 248.291 428.58 260.648 428.447 272.999V272.999Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_807_20">
            <rect
              width="401"
              height="258"
              fill="white"
              transform="translate(33 121)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</template>
<script lang="ts">
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { createUseStyles } from "@fresh8/vue-jss/src";

import { computed, defineComponent, PropType } from "vue";
import { injectTemplateSize } from "@fresh8/ad-data-composition/src/useTemplateSize";
import { injectTeamColors } from "../../../lib/teamBranding";

const useStyles = createUseStyles({
  body: {
    width: "97%",
    height: "97%",
    alignSelf: "baseline",
    display: "flex"
  },
  svg: {
    transform: props => props.transform,
    filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))"
  },
  container: {
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderStyle: "solid",
    borderWidth: props => props.borderWidth,
    background: "white",
    borderRadius: "9001px",
    margin: "0",
    borderColor: props => props.borderColor,
    boxShadow: props =>
      props.hideBoxShadow
        ? "0 2px 8px -2px rgba(0,0,0,0.16), 0 1px 2px rgba(0,0,0,.3)"
        : "",
    maxWidth: "32px",
    position: "relative",
    overflow: "hidden"
  }
});

export default defineComponent({
  name: "BaseballTeamJersey",
  props: {
    borderWidth: {
      type: String,
      required: false,
      default: "1px"
    },
    hideBoxShadow: {
      type: Boolean,
      required: false,
      default: false
    },
    homeOrAwayTeam: {
      type: String as PropType<"home" | "away">,
      required: true
    },
    transform: {
      type: String,
      required: false,
      default: "scale(1,1)"
    }
  },
  setup(props) {
    const brandContext = injectBrand();
    const template = injectTemplateSize();

    const teamColorsContext = injectTeamColors();

    const teamColors = computed(
      () => teamColorsContext.colors.value[props.homeOrAwayTeam]
    );

    const borderColor = computed(() => {
      if (
        brandContext?.brand.value?.adTemplate?.team?.useTeamColors &&
        teamColors.value?.banner.background
      ) {
        return teamColors.value?.banner.background;
      } else {
        return brandContext?.teamBranding.value.badge.borderColor;
      }
    });

    const reactiveStyles = computed(() => ({
      borderWidth: props.borderWidth,
      borderColor: borderColor.value,
      hideBoxShadow: props.hideBoxShadow,
      transform: props.transform
    }));

    const classes = useStyles(reactiveStyles);

    return {
      teamColors,
      classes,
      layoutClass: computed(() => template?.size.value?.name)
    };
  }
});
</script>
